<div class="background p10">
  <div class="header">
    <p class="font-18 text-heading-color font-weight-600 padding-top-10">Account Billing History</p>
  </div>
  <div class="container-filter">
    <div class="form-group" [formGroup]="filterForm">
      <select class="form-select {{ isAcura ? 'AcuraLinkText' : ''}}" (change)="dateFilterClick()"
        formControlName="filter_prov">
        <option *ngFor="let type of filterTypes; trackBy: trackByFilterType">
          {{ type.value }}
        </option>
      </select>
    </div>
    <div class="flex justify-content-center mt-10">
      <button mat-flat-button (click)="openAdvancedFilters()"
        class="edit-form-button button-background-transparent btn-width">
        Advanced Filter
      </button>
    </div>
  </div>

  <div *ngFor="let records of dataSource; trackBy: trackByBillingGroup">
    <p style="margin-top: 10px" class="text-color font-weight-600">{{records[0].key}}</p>
    <app-billing-cards>
      <div sample *ngFor="let record of records | slice: 1; index as i; last as isLast; trackBy: trackByBillingRecord">
        <div class="flex flex-items">
          <div class="flex-invoice">
            <p class="text-color type">{{record.desc}}</p>
          </div>
          <div class="flex-amount">
            <p *ngIf="record.amount >= 0; else negativeAmount" class="text-color font-weight-600">${{record.amount}}
            </p>
            <ng-template #negativeAmount>
              <p class="text-color font-weight-600">-${{record.amount * -1}}</p>
            </ng-template>
            <button *ngIf="record.filterType === 'Invoice'" mat-flat-button class="button-wv"
              (click)="viewInvoice(record, false)">
              Download
            </button>
          </div>
        </div>
        <div *ngIf="!isLast">
          <hr style="margin: 0;">
        </div>
      </div>
    </app-billing-cards>
  </div>
</div>
